var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"button",class:_vm.styles,attrs:{"fab":"","small":"","color":"white"},on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler.apply(null, arguments)}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }